import { isVariationOfAll } from "components/FlightTrends/TrendsFilters/filtersDrawerUtils";
import { uniqBy } from "lodash";
import type { Process, ProcessGroup } from "types/types";

export const getVisibleProcessesFromVisibleGroups = (
  visibleGroups: ProcessGroup[],
  excludeGroupsWithAllInTitle = true
): Process[] => {
  if (!visibleGroups) {
    return [];
  }

  // exclude "All" groups if we're on group tiles page with multiple groups (prevents
  // duplicate data in overall rollup)
  if (excludeGroupsWithAllInTitle && visibleGroups.length > 1) {
    visibleGroups = visibleGroups.filter(
      group => !isVariationOfAll(group.shortName)
    );
  }

  const visibleProcesses = visibleGroups.reduce(
    (acc, group) => [
      ...acc,
      ...(group.processesSortOrder
        ? group.processes.sort(
            (a, b) =>
              (group.processesSortOrder as string[]).indexOf(a.id) -
              (group.processesSortOrder as string[]).indexOf(b.id)
          )
        : group.processes),
    ],
    [] as Process[]
  );

  return uniqBy(visibleProcesses, process => {
    if (!process) {
      // this can happen if specifying invalid process via query param e.g. ?processes=invalidProcessId
      console.warn(
        "process is undefined -- invalid process specified in url?",
        process,
        { visibleGroups }
      );
    }
    return process?.id;
  }).filter(Boolean);
};
